import type { UsageSummaryResponse } from '../../lib/types.js';

/** One CSV field, quoted when it holds a comma, quote or line break. */
const field = (value: string | number | null): string => {
  const text = value === null ? '' : String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** The By user table for the period as CSV: one row per person, amounts in USD. */
export const usersCsv = (data: UsageSummaryResponse): string => {
  const header = [
    'User',
    'Turns',
    'Tokens',
    'Spend (USD)',
    'Per turn (USD)',
    'From cache share',
    'Spend last 7 days (USD)',
  ];
  const rows = data.byUser.map((u) => [
    u.label,
    u.turns,
    u.totalTokens,
    u.estimatedCostUsd.toFixed(2),
    u.costPerTurnUsd === null ? null : u.costPerTurnUsd.toFixed(4),
    u.fromCacheShare === null ? null : u.fromCacheShare.toFixed(3),
    u.last7DaysUsd.reduce((n, d) => n + d, 0).toFixed(2),
  ]);
  return [header, ...rows].map((r) => r.map(field).join(',')).join('\n');
};

/** Save the CSV through the browser, named for the period: "usage-2026-09-08-to-2026-10-07.csv". */
export const downloadUsersCsv = (data: UsageSummaryResponse): void => {
  const name = `usage-${data.since.slice(0, 10)}-to-${data.until.slice(0, 10)}.csv`;
  const url = URL.createObjectURL(new Blob([usersCsv(data)], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
};
